import { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AccountIcon from "./AccountIcon";
import RefreshContext from "../RefreshContext";
import apiClient   from "../lib/apiClient";


export default function EditDataView() {
  const [dataView, setDataView] = useState(null);
  const [accounts, setAccounts] = useState(null);
  const [categories, setCategories] = useState(null);
  const [changed, setChanged] = useState(false);
  const [name, setName] = useState("");

  const navigate = useNavigate();
  const { refresh, refreshKey } = useContext(RefreshContext);

  const { id } = useParams();
  const showPath = `/views/${id}`;
  useEffect(() => {
    apiClient.get(`/api/data_views/${id}`)
      .then(({data}) => {
        setDataView(data);
        setName(data.name);
      }).catch(console.error);
  }, [id, refreshKey]);

  useEffect(() => {
    const fetchAccounts = async () => {
      const path = `/api/accounts`;
      const {data} = await apiClient.get(path);

      // set the selected state based on the dataView
      data.forEach(account => {
        account.selected = dataView.account_ids.includes(account.id);
      })
      setAccounts(data.sort((a, b) => a.name.localeCompare(b.name)));
    }

    const fetchCategories = async () => {
      const path = `/api/categories/all`;
      const {data} = await apiClient.get(path);

      // set the selected state for the categories
      data.forEach(category => {
        category.selected = !dataView.ncategories.includes(category.name);
      })

      setCategories(data);
    }

    if (dataView) {
      fetchAccounts();
      fetchCategories();
    }
  }, [dataView]);

  function toggleAccount(account) {
    account.selected = !account.selected;
    setAccounts([...accounts]);
    setChanged(true);
  }

  function toggleCategory(category) {
    category.selected = !category.selected;

    console.log("Toggle", category.name, category.selected);
    setCategories([...categories]);
    setChanged(true);
  }

  function updateName(event) {
    setName(event.target.value);
    setChanged(true);
  }

  function doSave() {
    const path = `/api/data_views/${id}`;
    const body = {
      name: name,
      account_ids: accounts.filter(a => a.selected).map(a => a.id),
      ncategories: categories.filter(c => !c.selected).map(c => c.name)
    };

    apiClient.put(path, body)
      .then(() => {
        refresh();
        navigate(showPath);
      }).catch(console.error);
  }

  function selectAllCategories(selected) {
    categories.forEach(category => {
      category.selected = selected;
    });
    setCategories([...categories]);
    setChanged(true);
  }

  function selectAllAccounts(selected) {
    accounts.forEach(account => {
      account.selected = selected;
    });
    setAccounts([...accounts]);
    setChanged(true);
  }

  function doDuplicate() {
    const path = `/api/data_views/${id}/duplicate`;

    apiClient.post(path)
      .then(({data}) => {
        refresh();
        navigate(`/views/${data.id}#edit`);
      }).catch(console.error);
  }

  function doDelete() {
    const yes = window.confirm("Are you sure you want to delete this view?");
    if (!yes) return;
    const path = `/api/data_views/${id}`;

    apiClient.delete(path)
      .then(() => {
        refresh();
        navigate("/");
      }).catch(console.error);
  }

  function doCancel() {
    setChanged(false);
    navigate(showPath);
  }


  if (!dataView || !accounts || !categories) return null;


  return <div className="row">
    <div className="p-3">
      <div className="col-12 d-flex">
        <div className="flex-grow-1">
          <label className="form-label">View Name</label>
          <input type="text"
            value={name}
            onChange={updateName}
            className="form-control"
            placeholder="Name" />
        </div>
      </div>
      <p className="mt-2">
        Select the accounts and catagories you want to include or omit from this view.
      </p>

      <div className="row mt-2">
        <div className="col-6">
          <div className="d-flex align-items-baseline">
            <h5 className="flex-grow-1">Accounts</h5>
            <button className="btn btn-link" onClick={() => selectAllAccounts(true)}>
              Select All
            </button>
            <button className="btn btn-link" onClick={() => selectAllAccounts(false)}>
              Deselect All
            </button>
          </div>
          <div className="list-group">
            {accounts.map(account => {
              let className = "list-group-item cursor-pointer";
              if (account.selected) {
                className += " list-group-item-primary";
              }
              return <div key={account.id} className={className} onClick={() => toggleAccount(account)}>
                <AccountIcon accountType={account.account_type} />
                {account.name}
              </div>
            })}
          </div>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-baseline">
            <h5 className="flex-grow-1">Categories</h5>
            <button className="btn btn-link" onClick={() => selectAllCategories(true)}>
              Select All
            </button>
            <button className="btn btn-link" onClick={() => selectAllCategories(false)}>
              Deselect All
            </button>
          </div>
          <div className="list-group">
            {categories.map(category => {
              let className = "list-group-item cursor-pointer";
              if (category.selected) {
                className += " list-group-item-primary";
              }
              return <div key={category.id} className={className} onClick={() => toggleCategory(category)}>
                {category.name}
              </div>
            })}
          </div>
        </div>
      </div>
    </div>
    <div className="row sticky-bottom bg-body-highlight p-3 m-0 border-top">
      <div className="d-flex">
        <div className="flex-grow-1" />
        <button className="btn btn-outline-secondary ms-2" onClick={doCancel}>
          Cancel
        </button>
        <button className="btn btn-outline-secondary ms-2" onClick={doDuplicate}>
          Duplicate
        </button>
        <button className="btn btn-outline-danger ms-2" onClick={doDelete}>
          Delete
        </button>
        <button className="btn btn-primary ms-2" disabled={!changed} onClick={doSave}>
          Save
        </button>
      </div>
    </div>
  </div>
}



